import values from "lodash/values";

import { OceanIncoterms } from "../../../../../../../api/types/generated-types";

const { Fob, Exw, Fca, Fas, ...incoterms } = OceanIncoterms;

export const orderedOceanIncoterms = [Fob, Exw, Fca, Fas, ...values(incoterms)];
